import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useNotificationTemplateUIContext } from "./NotificationTemplateUIContext";
import NotificationTemplateTable from "./notification-template-table/NotificationTemplateTable";
import { NotificationTemplateFilter } from "./notification-template-table/organization-filter/NotificationTemplateFilter";
import { RoleChecker } from "../../../../RoleChecker";
import { Collapse } from "react-bootstrap";

export const NotificationTemplateCard = () => {
  const [openFilter, setOpenFilter] = useState(false);

  const notificationTemplateUIContext = useNotificationTemplateUIContext();
  const notificationTemplateUIProps = useMemo(() => {
    return {
      newNotificationTemplateButtonClick:
        notificationTemplateUIContext.newNotificationTemplateButtonClick
    };
  }, [notificationTemplateUIContext]);

  const allowCreate = RoleChecker("Create", "notification_template");
  const allowEdit = RoleChecker("Edit", "notification_template");
  const allowDelete = RoleChecker("Delete", "notification_template");

  return (
    <Card>
      <CardHeader title="Daftar Lembaga">
        <CardHeaderToolbar>
          <button
            className="btn btn-warning mx-1"
            onClick={() => setOpenFilter(!openFilter)}
          >
            Pencarian
          </button>
          {allowCreate && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={
                notificationTemplateUIProps.newNotificationTemplateButtonClick
              }
            >
              Tambah Template
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Collapse in={openFilter}>
          <div id="collapse-filter-notificationTemplate">
            <NotificationTemplateFilter />
          </div>
        </Collapse>
        <NotificationTemplateTable
          allowEdit={allowEdit}
          allowDelete={allowDelete}
        />
      </CardBody>
    </Card>
  );
};
